import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isModalOpen: false,
  isBulkScheduleModalOpen: false,
  scheduleCreated: false,
  isBulkSchedule: false,
  studentName: "",
  studentId: "",
  studentEmail: "",
  interviewType: "",
  interviewTypeId: "",
  validationErrors: {},
  form: {
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
  },
  editingScheduleId: null,
  initialFormValues: null,
  formInitializedForEdit: false,
};
export const schedulingSlice = createSlice({
  name: "scheduling",
  initialState,
  reducers: {
    toggleModalOpen: (state, action) => {
      state.isModalOpen = action.payload;
    },
    toggleBulkScheduleModalOpen: (state, action) => {
      state.isBulkScheduleModalOpen = action.payload;
    },
    updateFormField: (state, action) => {
      const { key, value } = action.payload;

      if (state.validationErrors && state.validationErrors[key]) {
        delete state.validationErrors[key];
      }
      if (key in state.form) {
        state.form[key] = value;
      } else {
        state[key] = value;
      }
    },
    setValidationErrors: (state, action) => {
      state.validationErrors = action.payload;
    },
    clearValidationErrors: (state) => {
      state.validationErrors = {};
    },
    resetScheduleForm: (state) => {
      const scheduleCreatedValue = state.scheduleCreated;
      const editingScheduleIdValue = state.editingScheduleId;
      const initialFormValuesValue = state.initialFormValues;
      const isModalOpenValue = state.isModalOpen;
      Object.assign(state, initialState);
      state.scheduleCreated = scheduleCreatedValue;
      state.editingScheduleId = editingScheduleIdValue;
      state.initialFormValues = initialFormValuesValue;
      state.isBulkSchedule = false;
      state.isModalOpen = isModalOpenValue;
    },
    setScheduleCreated: (state, action) => {
      state.scheduleCreated = action.payload;
    },
    setIsBulkSchedule: (state, action) => {
      state.isBulkSchedule = action.payload;
    },
    setEditingSchedule: (state, action) => {
      const { id, formValues } = action.payload;
      state.editingScheduleId = id;
      state.initialFormValues = formValues;
      
      if (formValues) {
        const { form, studentName, studentEmail, studentId, interviewType, interviewTypeId } = formValues;
        
        if (studentName !== undefined) {
          state.studentName = studentName || "";
        }
        if (studentEmail !== undefined) {
          state.studentEmail = studentEmail || "";
        }
        if (studentId !== undefined) {
          state.studentId = studentId || "";
        }
        if (interviewType !== undefined) {
          state.interviewType = interviewType || "";
        }
        if (interviewTypeId !== undefined) {
          state.interviewTypeId = interviewTypeId || "";
        }
        
        if (form) {
          if (form.startDate !== undefined) {
            state.form.startDate = form.startDate || "";
          }
          if (form.startTime !== undefined) {
            state.form.startTime = form.startTime || "";
          }
          if (form.endDate !== undefined) {
            state.form.endDate = form.endDate || "";
          }
          if (form.endTime !== undefined) {
            state.form.endTime = form.endTime || "";
          }
        }
      }
    },
    clearEditingSchedule: (state) => {
      state.editingScheduleId = null;
      state.initialFormValues = null;
    },
  },
});

const { actions, reducer: schedulingReducer } = schedulingSlice;

export const {
  toggleModalOpen,
  toggleBulkScheduleModalOpen,
  updateFormField,
  setValidationErrors,
  clearValidationErrors,
  resetScheduleForm,
  setScheduleCreated,
  setIsBulkSchedule,
  setEditingSchedule,
  clearEditingSchedule,
} = actions;

export default schedulingReducer;